import {
  Autocomplete,
    Box,
    Button,
    Chip,
    Grid,
    MenuItem,
    Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
    TextField,
    Tooltip,
    Typography,
  } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
  import React, { useState } from "react";
  import toast from "react-hot-toast";
  import { retrieveAllStakeholdersApi, updateStakeholderApi } from "../../../components/api/StakeholderApiService";
import FilterSelect from "../../../components/FilterSelect";
  
  const EditConsignee = (props) => {
    const { editConsignee, setEditConsignee } = props;
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const reference = editConsignee?.data?.reference || null;

    function retrieveCustomers() {
        retrieveAllStakeholdersApi("CUSTOMER")
          .then((response) => {
            setCustomers(response?.data);
          })
          .catch((error) => console.log(error.response?.data));
      }
    return (
      <>
        <Stack direcion="column">
          <Typography variant="body1" mb={2}>
            Edit Consignee
          </Typography>
          <Grid container item xs={12} spacing="8px">
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Consignee Code</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={editConsignee?.data?.code}
                onChange={(e) =>
                  setEditConsignee({
                    ...editConsignee,
                    data: {
                      ...editConsignee.data,
                      code: e.target.value,
                    },
                  })
                }
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Typography variant="body2">Consignee Name</Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={editConsignee?.data?.name}
                onChange={(e) =>
                  setEditConsignee({
                    ...editConsignee,
                    data: {
                      ...editConsignee.data,
                      name: e.target.value,
                    },
                  })
                }
              />
            </Grid>
<Grid item xs={12}>
  <Typography variant="body2" sx={{ mb: 1 }}>
    Contact Persons
  </Typography>
  <Table size="small" sx={{ border: "1px solid #ccc" }}>
    <TableHead>
      <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
        <TableCell>Default</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Email</TableCell>
        <TableCell>Phone 1</TableCell>
        <TableCell>Phone 2</TableCell>
        <TableCell>Position</TableCell>
        <TableCell align="center">Actions</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {(editConsignee?.data?.contactPersons || []).map((contact, idx) => (
        <TableRow key={idx}>
          <TableCell align="center">
            <Tooltip title={contact.isDefault ? "Default contact" : "Set as default"}>
              <span>
                <Button
                  size="small"
                  onClick={() => {
                    const updated = editConsignee.data.contactPersons.map((c, i) => ({ ...c, isDefault: i === idx }));
                    setEditConsignee({ ...editConsignee, data: { ...editConsignee.data, contactPersons: updated } });
                  }}
                  sx={{ minWidth: 0, p: 0.5, color: contact.isDefault ? "warning.main" : "action.disabled" }}
                >
                  {contact.isDefault ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                </Button>
              </span>
            </Tooltip>
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.name}
              onChange={(e) => {
                const updated = [...editConsignee.data.contactPersons];
                updated[idx].name = e.target.value;
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.email}
              onChange={(e) => {
                const updated = [...editConsignee.data.contactPersons];
                updated[idx].email = e.target.value;
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberOne}
              onChange={(e) => {
                const updated = [...editConsignee.data.contactPersons];
                updated[idx].phoneNumberOne = e.target.value;
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.phoneNumberTwo}
              onChange={(e) => {
                const updated = [...editConsignee.data.contactPersons];
                updated[idx].phoneNumberTwo = e.target.value;
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell>
            <TextField
              variant="standard"
              value={contact.position}
              onChange={(e) => {
                const updated = [...editConsignee.data.contactPersons];
                updated[idx].position = e.target.value;
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
              fullWidth
            />
          </TableCell>
          <TableCell align="center">
            <Button
              color="error"
              size="small"
              onClick={() => {
                const updated = [...editConsignee.data.contactPersons];
                updated.splice(idx, 1);
                setEditConsignee({
                  ...editConsignee,
                  data: { ...editConsignee.data, contactPersons: updated },
                });
              }}
            >
              Delete
            </Button>
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7} align="center">
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              const updated = [...(editConsignee.data.contactPersons || [])];
              updated.push({
                name: "",
                email: "",
                phoneNumberOne: "",
                phoneNumberTwo: "",
                position: "",
                isDefault: updated.length === 0,
              });
              setEditConsignee({
                ...editConsignee,
                data: { ...editConsignee.data, contactPersons: updated },
              });
            }}
          >
            + Add Contact Person
          </Button>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</Grid>
            <Grid item xs={12} sm={2}>
            <Typography variant="body2">Reference Customer</Typography>
            <Autocomplete
              options={customers}
              getOptionLabel={(option) =>
                `${option?.id || ""} - ${option?.name || ""}`
              }
              value={selectedCustomer}
              onChange={(event, newValue) => {
                setSelectedCustomer(newValue);
                setEditConsignee({
                  ...editConsignee,
                  data: {
                    ...editConsignee.data,
                    reference: newValue?.name || "",
                  },
                });
              }}
              onOpen={retrieveCustomers}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label={`${reference || ""}`}
                />
              )}
              renderTags={() => null}
            />
            {selectedCustomer && (
              <Box mt={2}>
                <Chip
                  label={`${selectedCustomer?.id || ""} - ${
                    selectedCustomer?.name || ""
                  }`}
                  onDelete={() => {
                    setSelectedCustomer(null);
                    setEditConsignee({
                      ...editConsignee,
                      data: {
                        ...editConsignee.data,
                        reference: "",
                      },
                    });
                  }}
                />
              </Box>
            )}
          </Grid>
             <Grid item xs={12} sm={2}>
                      <Typography variant="body2">Record Status</Typography>
                       <FilterSelect
                        menuType="recordStatus" 
                        value={editConsignee?.data?.status || ""}
                         onChange={(e) => {
                          setEditConsignee({
                            ...editConsignee,
                            data: {
                              ...editConsignee.data,
                              status: e.target.value || "",
                            },
                          });
                        }}
                        fullWidth
                      />
                    </Grid>
          </Grid>
          <Stack direction="row" spacing={1} mt={1}>
            <Button
              variant="outlined"
              onClick={() =>
                setEditConsignee({ visible: false, data: null, index: null })
              }
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                updateStakeholderApi(editConsignee.data.id, editConsignee.data)
                  .then((response) => {
                    toast.success("Consignee edited successfully.");
                    window.location.reload();
  
                    setEditConsignee({ visible: false, data: null, index: null });
                  })
                  .catch((error) => {
                    toast.error("Something went wrong.");
                    console.log(error.response.data);
                  });
              }}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                editConsignee.data.status = "PASSIVE";
                updateStakeholderApi(editConsignee.data.id, editConsignee.data)
                  .then((response) => {
                    toast.success("Consignee deleted successfully.");
                    window.location.reload();
  
                    setEditConsignee({ visible: false, data: null, index: null });
                  })
                  .catch((error) => {
                    toast.error("Something went wrong.");
                    console.log(error.response.data);
                  });
              }}
            >
              Delete
            </Button>
          </Stack>
        </Stack>
      </>
    );
  };
  
  export default EditConsignee;
  